export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.creamo.kr/api/v1';
export const TOKEN_KEY: string = process.env.REACT_APP_TOKEN_KEY || 'addi_token_test';
export const USER_KEY: string = process.env.REACT_APP_USER_KEY || 'addi_user_key';
export const AGREE_KEY: string = process.env.REACT_APP_AGREE_KEY || 'addi_agree_test';